module.exports = __webpack_public_path__ + "static/assets/f8ff5dbef05bc3337cd3660fb956cffa.svg";